module.exports = __webpack_public_path__ + "static/media/logo-quantum.5a5492a8.png";